import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css'],
  standalone: false
})
export class PrivacyComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
    const downLink = document.createElement('a');
          downLink.href = '../assets/documents/Clover Privacy Policy for Stellar ScaleTech Card Payments 2025-7-9.pdf';
          downLink.click();
          window.open(downLink.href, '_blank');
  }
}
